"use strict";
var Ajaxinate = function e(t) {
  (this.settings = Object.assign(
    {
      method: "scroll",
      container: "#AjaxinateLoop",
      pagination: "#AjaxinatePagination",
      offset: 0,
      loadingText: "Loading",
      callback: null,
    },
    t || {}
  )),
    (this.addScrollListeners = this.addScrollListeners.bind(this)),
    (this.addClickListener = this.addClickListener.bind(this)),
    (this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this)),
    (this.stopMultipleClicks = this.stopMultipleClicks.bind(this)),
    (this.removeClickListener = this.removeClickListener.bind(this)),
    (this.removeScrollListener = this.removeScrollListener.bind(this)),
    (this.destroy = this.destroy.bind(this)),
    (this.containerElement = document.querySelector(this.settings.container)),
    (this.paginationElement = document.querySelector(this.settings.pagination)),
    this.initialize();
};
(Ajaxinate.prototype.initialize = function e() {
  this.containerElement &&
    { click: this.addClickListener, scroll: this.addScrollListeners }[
      this.settings.method
    ]();
}),
  (Ajaxinate.prototype.addScrollListeners = function e() {
    this.paginationElement &&
      (document.addEventListener("scroll", this.checkIfPaginationInView),
      window.addEventListener("resize", this.checkIfPaginationInView),
      window.addEventListener(
        "orientationchange",
        this.checkIfPaginationInView
      ));
  }),
  (Ajaxinate.prototype.addClickListener = function e() {
    this.paginationElement &&
      ((this.nextPageLinkElement = this.paginationElement.querySelector("a")),
      (this.clickActive = !0),
      void 0 !== this.nextPageLinkElement &&
        null !== this.nextPageLinkElement &&
        this.nextPageLinkElement.addEventListener(
          "click",
          this.stopMultipleClicks
        ));
  }),
  (Ajaxinate.prototype.stopMultipleClicks = function e(t) {
    t.preventDefault(),
      this.clickActive &&
        ((this.nextPageLinkElement.innerText = this.settings.loadingText),
        (this.nextPageUrl = this.nextPageLinkElement.href),
        (this.clickActive = !1),
        this.loadMore());
  }),
  (Ajaxinate.prototype.checkIfPaginationInView = function e() {
    var t =
        this.paginationElement.getBoundingClientRect().top -
        this.settings.offset,
      i =
        this.paginationElement.getBoundingClientRect().bottom +
        this.settings.offset;
    t <= window.innerHeight &&
      i >= 0 &&
      ((this.nextPageLinkElement = this.paginationElement.querySelector("a")),
      this.removeScrollListener(),
      this.nextPageLinkElement &&
        ((this.nextPageLinkElement.innerText = this.settings.loadingText),
        (this.nextPageUrl = this.nextPageLinkElement.href),
        this.loadMore()));
  }),
  (Ajaxinate.prototype.loadMore = function e() {
    (this.request = new XMLHttpRequest()),
      (this.request.onreadystatechange = function e() {
        if (4 === this.request.readyState && 200 === this.request.status) {
          var t = this.request.responseXML.querySelectorAll(
              this.settings.container
            )[0],
            i = this.request.responseXML.querySelectorAll(
              this.settings.pagination
            )[0];
          this.containerElement.insertAdjacentHTML("beforeend", t.innerHTML),
            (this.paginationElement.innerHTML = i.innerHTML),
            this.settings.callback &&
              "function" == typeof this.settings.callback &&
              this.settings.callback(this.request.responseXML),
            this.initialize();
        }
      }.bind(this)),
      this.request.open("GET", this.nextPageUrl),
      (this.request.responseType = "document"),
      this.request.send();
  }),
  (Ajaxinate.prototype.removeClickListener = function e() {
    this.nextPageLinkElement.removeEventListener(
      "click",
      this.stopMultipleClicks
    );
  }),
  (Ajaxinate.prototype.removeScrollListener = function e() {
    document.removeEventListener("scroll", this.checkIfPaginationInView),
      window.removeEventListener("resize", this.checkIfPaginationInView),
      window.removeEventListener(
        "orientationchange",
        this.checkIfPaginationInView
      );
  }),
  (Ajaxinate.prototype.destroy = function e() {
    return (
      { click: this.removeClickListener, scroll: this.removeScrollListener }[
        this.settings.method
      ](),
      this
    );
  });
